import { render, staticRenderFns } from "./main-search.vue?vue&type=template&id=3f0b3348&"
import script from "./main-search.vue?vue&type=script&lang=js&"
export * from "./main-search.vue?vue&type=script&lang=js&"
import style0 from "./main-search.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports